import { defineRouting } from "next-intl/routing";

const locales = ["en", "ru", "de"];

const defaultLocale = "en";

// https://next-intl-docs.vercel.app/blog/next-intl-3-22
export const routing = defineRouting({
  // A list of all locales that are supported
  locales,

  // If this locale is matched, pathnames work without a prefix (e.g. `/about`)
  defaultLocale,

  // https://github.com/amannn/next-intl/issues/594
  // localePrefix: "always",
  localePrefix: "as-needed",
  localeDetection: true,

  alternateLinks: true,
});
